export default "__VITE_ASSET__CwNd1nlQ__"